<div id="map-base" class="map-container">
  <div
    id="gcMap"
    leaflet
    [leafletOptions]="options"
    (leafletMapReady)="onMapReady($event)"
    (click)="onMapClick()"
    (leafletMapMove)="isMyLocationVisible()"
  ></div>

  <div class="connector-charger-status-container" *ngIf="showChargerStatus()">
    <app-connector-charging-status></app-connector-charging-status>
  </div>

  <div class="map-controls">
    <button mat-icon-button (click)="jumpToMyLocation()" #jumpToMyLocationButton [disabled]="!isLocationAvailable()">
      <mat-icon>my_location</mat-icon>
    </button>
  </div>

  <!-- Position the search control at the top left -->
  <div class="topbar-search-bar">
    <button
      mat-icon-button
      onclick="document.querySelector('mat-sidenav').classList.toggle('opened')"
      class="show-mobile toggle-sidebar"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <div class="search-control-overlay">
      <app-search-control [map]="map"></app-search-control>
    </div>

    <div class="map-ad-slot">
      <app-ad-strip placement="MAP_VIEW"></app-ad-strip>
    </div>
  </div>

  <div class="hide-mobile topbar-user-dropdown" tourAnchor="user-dropdown-tour-step">
    <a [href]="advertiseUrl" target="_blank" class="topbar-advertise-btn"
       matTooltip="Advertise on GitCharger" matTooltipPosition="below">
      <mat-icon>campaign</mat-icon>
    </a>
    <app-user-dropdown></app-user-dropdown>
  </div>

  <div
    class="tour-marker-overlay"
    tourAnchor="welcome-tour-step"
    style="height:0;left:calc(50% - 80px);top:calc(50% - 80px);width:0"
  ></div>

  <div
    class="tour-marker-overlay"
    tourAnchor="marker-tour-step"
  ></div>

  <router-outlet></router-outlet>
</div>
